var map = {
	"./": [
		27,
		9
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Black.otf": [
		268,
		7,
		145
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Book.otf": [
		269,
		7,
		146
	],
	"./assets/fonts/Gotham-Font/AvenirLTStd-Roman.otf": [
		270,
		7,
		147
	],
	"./assets/fonts/Perpetua/Perpetua Bold font.ttf": [
		271,
		7,
		148
	],
	"./assets/fonts/Perpetua/per_____.ttf": [
		272,
		7,
		149
	],
	"./assets/fonts/Perpetua/perb____.ttf": [
		273,
		7,
		150
	],
	"./assets/fonts/Perpetua/perpeta.ttf": [
		274,
		7,
		151
	],
	"./assets/fonts/Perpetua/unicode.perpetua.ttf": [
		275,
		7,
		152
	],
	"./assets/fonts/ProximaNova/ProximaNova-Regular.otf": [
		276,
		7,
		153
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Bold.otf": [
		277,
		7,
		154
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Light.otf": [
		278,
		7,
		155
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Alt_Thin.otf": [
		279,
		7,
		156
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Black.otf": [
		280,
		7,
		157
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Bold.otf": [
		281,
		7,
		158
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Extrabold.otf": [
		282,
		7,
		159
	],
	"./assets/fonts/ProximaNova/Proxima_Nova_Thin.otf": [
		283,
		7,
		160
	],
	"./assets/images/Cooking.png": [
		284,
		7,
		181
	],
	"./assets/images/DACE_PROMO_final.mp4": [
		200,
		7,
		161
	],
	"./assets/images/RightArrow.svg": [
		201,
		7,
		162
	],
	"./assets/images/Right_arraw.png": [
		191,
		7,
		182
	],
	"./assets/images/UpArrow.png": [
		238,
		7,
		183
	],
	"./assets/images/VB DACE  _final.mp4": [
		239,
		7,
		163
	],
	"./assets/images/Vector.png": [
		285,
		7,
		184
	],
	"./assets/images/active_star.png": [
		286,
		7,
		185
	],
	"./assets/images/arrow1.png": [
		287,
		7,
		186
	],
	"./assets/images/arrow_gold.png": [
		202,
		7,
		187
	],
	"./assets/images/arrow_grey.png": [
		246,
		7,
		188
	],
	"./assets/images/banner/vb-dace-independence-day.jpg": [
		288,
		7,
		189
	],
	"./assets/images/cart_icon.jpg": [
		289,
		7,
		190
	],
	"./assets/images/chevron-down.png": [
		290,
		7,
		191
	],
	"./assets/images/chevron-up.png": [
		291,
		7,
		192
	],
	"./assets/images/circle_check_full_green.png": [
		232,
		7,
		193
	],
	"./assets/images/coolicon.png": [
		199,
		7,
		194
	],
	"./assets/images/delete.png": [
		240,
		7,
		195
	],
	"./assets/images/disabled_star.png": [
		292,
		7,
		196
	],
	"./assets/images/dot.png": [
		293,
		7,
		197
	],
	"./assets/images/down_button.png": [
		256,
		7,
		198
	],
	"./assets/images/eye.png": [
		236,
		7,
		199
	],
	"./assets/images/fb_logo.png": [
		294,
		7,
		200
	],
	"./assets/images/filter.png": [
		257,
		7,
		201
	],
	"./assets/images/flag.png": [
		295,
		7,
		202
	],
	"./assets/images/heart_icon.jpg": [
		296,
		7,
		203
	],
	"./assets/images/heart_icon.png": [
		297,
		7,
		204
	],
	"./assets/images/home/Arrow 2.jpg": [
		298,
		7,
		205
	],
	"./assets/images/home/LARGER MID SECTION BANNER.png": [
		196,
		7,
		206
	],
	"./assets/images/home/RED SMALL BANNER.png": [
		203,
		7,
		207
	],
	"./assets/images/home/SILVER SMALL BANNER.png": [
		204,
		7,
		208
	],
	"./assets/images/home/coolicon.jpg": [
		299,
		7,
		209
	],
	"./assets/images/home/diwali.jpg": [
		300,
		7,
		210
	],
	"./assets/images/home/pressBlock/company1.png": [
		205,
		7,
		211
	],
	"./assets/images/home/pressBlock/company2.png": [
		206,
		7,
		212
	],
	"./assets/images/home/pressBlock/company3.png": [
		207,
		7,
		213
	],
	"./assets/images/home/pressBlock/company4.png": [
		208,
		7,
		214
	],
	"./assets/images/home/pressBlock/company5.png": [
		209,
		7,
		215
	],
	"./assets/images/home/pressBlock/company6.png": [
		210,
		7,
		216
	],
	"./assets/images/home/serviceImage_1.png": [
		211,
		7,
		217
	],
	"./assets/images/home/serviceImage_2.png": [
		212,
		7,
		218
	],
	"./assets/images/home/serviceImage_3.png": [
		213,
		7,
		219
	],
	"./assets/images/home/serviceImage_4.png": [
		214,
		7,
		220
	],
	"./assets/images/home/serviceImage_5.png": [
		215,
		7,
		221
	],
	"./assets/images/home/slide/image1.png": [
		301,
		7,
		222
	],
	"./assets/images/home/slide/image2.png": [
		302,
		7,
		223
	],
	"./assets/images/home/slide/image3.png": [
		303,
		7,
		224
	],
	"./assets/images/home/slide/image4.png": [
		304,
		7,
		225
	],
	"./assets/images/home/slide/image5.png": [
		305,
		7,
		226
	],
	"./assets/images/home/slide/image6.png": [
		306,
		7,
		227
	],
	"./assets/images/home/slide/image7.png": [
		307,
		7,
		228
	],
	"./assets/images/home/slide/image8.png": [
		308,
		7,
		229
	],
	"./assets/images/home/slide/image9.png": [
		309,
		7,
		230
	],
	"./assets/images/home/slide/slide1.png": [
		241,
		7,
		231
	],
	"./assets/images/home/slide/slide2.png": [
		253,
		7,
		232
	],
	"./assets/images/home/slide/slide3.png": [
		254,
		7,
		233
	],
	"./assets/images/home/slide/slide4.png": [
		310,
		7,
		234
	],
	"./assets/images/home/slide/slide5.png": [
		311,
		7,
		235
	],
	"./assets/images/home/welcome_image.png": [
		312,
		7,
		236
	],
	"./assets/images/home/welcome_image_mobile.jpg": [
		313,
		7,
		237
	],
	"./assets/images/icons-new/customer-support.png": [
		217,
		7,
		238
	],
	"./assets/images/icons-new/quality-guaranteed.png": [
		218,
		7,
		239
	],
	"./assets/images/icons-new/quick-shipping.png": [
		219,
		7,
		240
	],
	"./assets/images/icons-new/secured-payments.png": [
		220,
		7,
		241
	],
	"./assets/images/icons/google-play-badge.png": [
		216,
		7,
		242
	],
	"./assets/images/imageLft_login.png": [
		314,
		7,
		243
	],
	"./assets/images/instagram_logo.png": [
		315,
		7,
		244
	],
	"./assets/images/leftArrow.png": [
		190,
		7,
		245
	],
	"./assets/images/leftArrow_a.png": [
		316,
		7,
		246
	],
	"./assets/images/lindedin_logo.png": [
		317,
		7,
		247
	],
	"./assets/images/loading.gif": [
		318,
		7,
		248
	],
	"./assets/images/logo.jpg": [
		319,
		7,
		249
	],
	"./assets/images/logo.png": [
		193,
		7,
		250
	],
	"./assets/images/logo_1x.png": [
		320,
		7,
		251
	],
	"./assets/images/logo_2x.png": [
		321,
		7,
		252
	],
	"./assets/images/logo_3x.png": [
		233,
		7,
		253
	],
	"./assets/images/logo_4x.png": [
		322,
		7,
		254
	],
	"./assets/images/logo_with_title.png": [
		323,
		7,
		255
	],
	"./assets/images/logo_with_title_old.png": [
		324,
		7,
		256
	],
	"./assets/images/minus.png": [
		234,
		7,
		257
	],
	"./assets/images/newsfeed_logo.png": [
		325,
		7,
		258
	],
	"./assets/images/next-btn-old.png": [
		326,
		7,
		259
	],
	"./assets/images/next-btn.png": [
		194,
		7,
		260
	],
	"./assets/images/offer/ALLPROBackpack.png": [
		247,
		7,
		261
	],
	"./assets/images/offer/SignatureBlackFront.png": [
		248,
		7,
		262
	],
	"./assets/images/offer/SignatureBlackSide.png": [
		327,
		7,
		263
	],
	"./assets/images/pagNext.png": [
		244,
		7,
		264
	],
	"./assets/images/pagPrevious.png": [
		245,
		7,
		265
	],
	"./assets/images/plus.png": [
		235,
		7,
		266
	],
	"./assets/images/pressNxtBtn.svg": [
		221,
		7,
		164
	],
	"./assets/images/pressPrevBtn.svg": [
		222,
		7,
		165
	],
	"./assets/images/prev-btn-old.png": [
		328,
		7,
		267
	],
	"./assets/images/prev-btn.png": [
		195,
		7,
		268
	],
	"./assets/images/product/Product_1.png": [
		329,
		7,
		269
	],
	"./assets/images/product/Product_2.png": [
		330,
		7,
		270
	],
	"./assets/images/product/Product_3.png": [
		331,
		7,
		271
	],
	"./assets/images/product/Product_4.png": [
		332,
		7,
		272
	],
	"./assets/images/product/category_banner.png": [
		258,
		7,
		273
	],
	"./assets/images/product/videoImg1.png": [
		259,
		7,
		274
	],
	"./assets/images/product/videoImg2.png": [
		260,
		7,
		275
	],
	"./assets/images/product/videoImg3.png": [
		261,
		7,
		276
	],
	"./assets/images/rightArrow.png": [
		192,
		7,
		277
	],
	"./assets/images/right_arrow_white.png": [
		223,
		7,
		278
	],
	"./assets/images/search_icon.png": [
		224,
		7,
		279
	],
	"./assets/images/sign_in_icon.jpg": [
		333,
		7,
		280
	],
	"./assets/images/square_minus.png": [
		242,
		7,
		281
	],
	"./assets/images/square_plus.png": [
		243,
		7,
		282
	],
	"./assets/images/tope.mp4": [
		225,
		7,
		166
	],
	"./assets/images/x-circle.png": [
		334,
		7,
		283
	],
	"./assets/images/x-shape.png": [
		335,
		7,
		284
	],
	"./assets/images/youtube_logo.png": [
		336,
		7,
		285
	],
	"./assets/scss/abstracts/_abstracts.scss": [
		337,
		7,
		180
	],
	"./assets/scss/abstracts/font.scss": [
		338,
		7,
		121
	],
	"./assets/scss/abstracts/functions.scss": [
		339,
		7,
		122
	],
	"./assets/scss/abstracts/mixins.scss": [
		340,
		7,
		123
	],
	"./assets/scss/abstracts/variables.scss": [
		341,
		7,
		124
	],
	"./assets/scss/common.scss": [
		342,
		7,
		125
	],
	"./assets/scss/default/default.scss": [
		343,
		7,
		126
	],
	"./assets/scss/default/utility.scss": [
		344,
		7,
		127
	],
	"./assets/scss/icons/fonts/icomoon.eot": [
		345,
		7,
		167
	],
	"./assets/scss/icons/fonts/icomoon.svg": [
		346,
		7,
		168
	],
	"./assets/scss/icons/fonts/icomoon.ttf": [
		347,
		7,
		169
	],
	"./assets/scss/icons/fonts/icomoon.woff": [
		348,
		7,
		170
	],
	"./assets/scss/icons/selection": [
		145,
		3,
		115
	],
	"./assets/scss/icons/selection.json": [
		145,
		3,
		115
	],
	"./assets/scss/icons/style.css": [
		349,
		7,
		120
	],
	"./assets/scss/index.scss": [
		116,
		7
	],
	"./assets/scss/layouts/AuthLayout.scss": [
		112,
		7
	],
	"./assets/scss/layouts/CategoryLayout.scss": [
		350,
		7,
		128
	],
	"./assets/scss/layouts/HomeLayout.scss": [
		351,
		7,
		129
	],
	"./assets/scss/layouts/ProductLayout.scss": [
		352,
		7,
		130
	],
	"./assets/scss/layouts/cartLayout.scss": [
		353,
		7,
		131
	],
	"./assets/scss/vendors/vendors-dir.scss": [
		354,
		7,
		132
	],
	"./assets/svg/Facebook-Fill.svg": [
		226,
		7,
		171
	],
	"./assets/svg/Facebook.svg": [
		227,
		7,
		172
	],
	"./assets/svg/Insta-Fill.svg": [
		228,
		7,
		173
	],
	"./assets/svg/Insta.svg": [
		229,
		7,
		174
	],
	"./assets/svg/Youtube-Fill.svg": [
		230,
		7,
		175
	],
	"./assets/svg/Youtube.svg": [
		231,
		7,
		176
	],
	"./assets/svg/leftArrow.svg": [
		197,
		7,
		177
	],
	"./assets/svg/logo.svg": [
		355,
		7,
		178
	],
	"./assets/svg/rightArrow.svg": [
		198,
		7,
		179
	],
	"./component/Currency/page": [
		128,
		9,
		103
	],
	"./component/Currency/page.jsx": [
		128,
		9,
		103
	],
	"./component/StaticPageComponent/StaticPageComponent": [
		143,
		9,
		0,
		1,
		2,
		3,
		77
	],
	"./component/StaticPageComponent/StaticPageComponent.js": [
		143,
		9,
		0,
		1,
		2,
		3,
		77
	],
	"./component/StoreComponent": [
		58,
		9,
		5,
		51
	],
	"./component/StoreComponent/": [
		58,
		9,
		5,
		51
	],
	"./component/StoreComponent/Addresscard/AddressCard": [
		138,
		9,
		5,
		91
	],
	"./component/StoreComponent/Addresscard/AddressCard.js": [
		138,
		9,
		5,
		91
	],
	"./component/StoreComponent/Addresscard/styles.scss": [
		251,
		7,
		133
	],
	"./component/StoreComponent/index": [
		58,
		9,
		5,
		51
	],
	"./component/StoreComponent/index.js": [
		58,
		9,
		5,
		51
	],
	"./component/auth": [
		53,
		9,
		0,
		1,
		2,
		3,
		30
	],
	"./component/auth/": [
		53,
		9,
		0,
		1,
		2,
		3,
		30
	],
	"./component/auth/ForgotPwd": [
		48,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ForgotPwd/": [
		48,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ForgotPwd/index": [
		48,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ForgotPwd/index.js": [
		48,
		9,
		0,
		1,
		2,
		3,
		39
	],
	"./component/auth/ForgotPwd/validate": [
		146,
		9,
		104
	],
	"./component/auth/ForgotPwd/validate.js": [
		146,
		9,
		104
	],
	"./component/auth/Login": [
		49,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/": [
		49,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/index": [
		49,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/index.js": [
		49,
		9,
		0,
		1,
		2,
		3,
		37
	],
	"./component/auth/Login/validate": [
		147,
		9,
		105
	],
	"./component/auth/Login/validate.js": [
		147,
		9,
		105
	],
	"./component/auth/ResetPwd": [
		50,
		9,
		0,
		1,
		2,
		50,
		41
	],
	"./component/auth/ResetPwd/": [
		50,
		9,
		0,
		1,
		2,
		50,
		41
	],
	"./component/auth/ResetPwd/index": [
		50,
		9,
		0,
		1,
		2,
		50,
		41
	],
	"./component/auth/ResetPwd/index.js": [
		50,
		9,
		0,
		1,
		2,
		50,
		41
	],
	"./component/auth/Signup": [
		51,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/auth/Signup/": [
		51,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/auth/Signup/index": [
		51,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/auth/Signup/index.js": [
		51,
		9,
		0,
		1,
		2,
		3,
		32
	],
	"./component/auth/Signup/validate": [
		148,
		9,
		106
	],
	"./component/auth/Signup/validate.js": [
		148,
		9,
		106
	],
	"./component/auth/index": [
		53,
		9,
		0,
		1,
		2,
		3,
		30
	],
	"./component/auth/index.js": [
		53,
		9,
		0,
		1,
		2,
		3,
		30
	],
	"./component/blogDetail": [
		59,
		9,
		0,
		1,
		52
	],
	"./component/blogDetail/": [
		59,
		9,
		0,
		1,
		52
	],
	"./component/blogDetail/index": [
		59,
		9,
		0,
		1,
		52
	],
	"./component/blogDetail/index.js": [
		59,
		9,
		0,
		1,
		52
	],
	"./component/blogs": [
		60,
		9,
		0,
		1,
		7,
		9,
		42
	],
	"./component/blogs/": [
		60,
		9,
		0,
		1,
		7,
		9,
		42
	],
	"./component/blogs/blogCard": [
		139,
		9,
		7,
		97
	],
	"./component/blogs/blogCard.js": [
		139,
		9,
		7,
		97
	],
	"./component/blogs/index": [
		60,
		9,
		0,
		1,
		7,
		9,
		42
	],
	"./component/blogs/index.js": [
		60,
		9,
		0,
		1,
		7,
		9,
		42
	],
	"./component/cart": [
		61,
		9,
		0,
		1,
		36
	],
	"./component/cart/": [
		61,
		9,
		0,
		1,
		36
	],
	"./component/cart/dosa": [
		149,
		9,
		0,
		1,
		2,
		3,
		75
	],
	"./component/cart/dosa.js": [
		149,
		9,
		0,
		1,
		2,
		3,
		75
	],
	"./component/cart/index": [
		61,
		9,
		0,
		1,
		36
	],
	"./component/cart/index.js": [
		61,
		9,
		0,
		1,
		36
	],
	"./component/cart/originalIndex": [
		150,
		9,
		0,
		1,
		2,
		3,
		76
	],
	"./component/cart/originalIndex.js": [
		150,
		9,
		0,
		1,
		2,
		3,
		76
	],
	"./component/cart/test": [
		151,
		9,
		0,
		1,
		2,
		3,
		73
	],
	"./component/cart/test.js": [
		151,
		9,
		0,
		1,
		2,
		3,
		73
	],
	"./component/category": [
		62,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/category/": [
		62,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/category/index": [
		62,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/category/index.js": [
		62,
		9,
		0,
		1,
		2,
		4,
		31
	],
	"./component/category/old-index": [
		152,
		9,
		0,
		1,
		2,
		3,
		78
	],
	"./component/category/old-index.js": [
		152,
		9,
		0,
		1,
		2,
		3,
		78
	],
	"./component/category/tabs.category": [
		144,
		9,
		2,
		5,
		4,
		8,
		82
	],
	"./component/category/tabs.category.js": [
		144,
		9,
		2,
		5,
		4,
		8,
		82
	],
	"./component/common": [
		75,
		7,
		64
	],
	"./component/common/": [
		75,
		7,
		64
	],
	"./component/common/ChefNavTabs": [
		90,
		9,
		48
	],
	"./component/common/ChefNavTabs/": [
		90,
		9,
		48
	],
	"./component/common/ChefNavTabs/index": [
		90,
		9,
		48
	],
	"./component/common/ChefNavTabs/index.js": [
		90,
		9,
		48
	],
	"./component/common/ChefNavTabs/style.scss": [
		262,
		7,
		134
	],
	"./component/common/CommonPageLoader": [
		24,
		9
	],
	"./component/common/CommonPageLoader/": [
		24,
		9
	],
	"./component/common/CommonPageLoader/index": [
		24,
		9
	],
	"./component/common/CommonPageLoader/index.js": [
		24,
		9
	],
	"./component/common/CommonPageLoader/style.scss": [
		114,
		7
	],
	"./component/common/CommonTableLoader": [
		70,
		9,
		49
	],
	"./component/common/CommonTableLoader/": [
		70,
		9,
		49
	],
	"./component/common/CommonTableLoader/index": [
		70,
		9,
		49
	],
	"./component/common/CommonTableLoader/index.js": [
		70,
		9,
		49
	],
	"./component/common/CommonTableLoader/style.scss": [
		263,
		7,
		135
	],
	"./component/common/ErrorComponent": [
		57,
		9,
		61
	],
	"./component/common/ErrorComponent/": [
		57,
		9,
		61
	],
	"./component/common/ErrorComponent/index": [
		57,
		9,
		61
	],
	"./component/common/ErrorComponent/index.js": [
		57,
		9,
		61
	],
	"./component/common/FormErrorMessage": [
		47,
		9,
		62
	],
	"./component/common/FormErrorMessage/": [
		47,
		9,
		62
	],
	"./component/common/FormErrorMessage/index": [
		47,
		9,
		62
	],
	"./component/common/FormErrorMessage/index.js": [
		47,
		9,
		62
	],
	"./component/common/NormalButton": [
		71,
		9,
		63
	],
	"./component/common/NormalButton/": [
		71,
		9,
		63
	],
	"./component/common/NormalButton/index": [
		71,
		9,
		63
	],
	"./component/common/NormalButton/index.js": [
		71,
		9,
		63
	],
	"./component/common/NormalInput": [
		72,
		9,
		54
	],
	"./component/common/NormalInput/": [
		72,
		9,
		54
	],
	"./component/common/NormalInput/NormalInput.scss": [
		264,
		7,
		136
	],
	"./component/common/NormalInput/index": [
		72,
		9,
		54
	],
	"./component/common/NormalInput/index.js": [
		72,
		9,
		54
	],
	"./component/common/NormalSearch": [
		63,
		9,
		59
	],
	"./component/common/NormalSearch/": [
		63,
		9,
		59
	],
	"./component/common/NormalSearch/NormalSearch.scss": [
		255,
		7,
		137
	],
	"./component/common/NormalSearch/index": [
		63,
		9,
		59
	],
	"./component/common/NormalSearch/index.js": [
		63,
		9,
		59
	],
	"./component/common/NormalSelect": [
		73,
		9,
		6,
		55
	],
	"./component/common/NormalSelect/": [
		73,
		9,
		6,
		55
	],
	"./component/common/NormalSelect/index": [
		73,
		9,
		6,
		55
	],
	"./component/common/NormalSelect/index.js": [
		73,
		9,
		6,
		55
	],
	"./component/common/NormalSelect/select.scss": [
		265,
		7,
		138
	],
	"./component/common/Slider": [
		34,
		9,
		2,
		53
	],
	"./component/common/Slider/": [
		34,
		9,
		2,
		53
	],
	"./component/common/Slider/index": [
		34,
		9,
		2,
		53
	],
	"./component/common/Slider/index.js": [
		34,
		9,
		2,
		53
	],
	"./component/common/TableWrapper": [
		74,
		9,
		56
	],
	"./component/common/TableWrapper/": [
		74,
		9,
		56
	],
	"./component/common/TableWrapper/index": [
		74,
		9,
		56
	],
	"./component/common/TableWrapper/index.js": [
		74,
		9,
		56
	],
	"./component/common/TableWrapper/table.scss": [
		266,
		7,
		139
	],
	"./component/common/index": [
		75,
		7,
		64
	],
	"./component/common/index.js": [
		75,
		7,
		64
	],
	"./component/customerService": [
		69,
		9,
		4,
		35
	],
	"./component/customerService/": [
		69,
		9,
		4,
		35
	],
	"./component/customerService/index": [
		69,
		9,
		4,
		35
	],
	"./component/customerService/index.js": [
		69,
		9,
		4,
		35
	],
	"./component/home": [
		45,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./component/home/": [
		45,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./component/home/Banner": [
		36,
		9,
		65
	],
	"./component/home/Banner/": [
		36,
		9,
		65
	],
	"./component/home/Banner/index": [
		36,
		9,
		65
	],
	"./component/home/Banner/index.js": [
		36,
		9,
		65
	],
	"./component/home/CollectionTabs": [
		64,
		9,
		0,
		1,
		4,
		8,
		28
	],
	"./component/home/CollectionTabs/": [
		64,
		9,
		0,
		1,
		4,
		8,
		28
	],
	"./component/home/CollectionTabs/index": [
		64,
		9,
		0,
		1,
		4,
		8,
		28
	],
	"./component/home/CollectionTabs/index.js": [
		64,
		9,
		0,
		1,
		4,
		8,
		28
	],
	"./component/home/DetailPage1": [
		37,
		9,
		66
	],
	"./component/home/DetailPage1/": [
		37,
		9,
		66
	],
	"./component/home/DetailPage1/index": [
		37,
		9,
		66
	],
	"./component/home/DetailPage1/index.js": [
		37,
		9,
		66
	],
	"./component/home/FooterBlock": [
		43,
		9,
		0,
		1,
		3,
		69,
		38
	],
	"./component/home/FooterBlock/": [
		43,
		9,
		0,
		1,
		3,
		69,
		38
	],
	"./component/home/FooterBlock/index": [
		43,
		9,
		0,
		1,
		3,
		69,
		38
	],
	"./component/home/FooterBlock/index.js": [
		43,
		9,
		0,
		1,
		3,
		69,
		38
	],
	"./component/home/ImgBlocks": [
		39,
		9,
		2,
		25,
		43
	],
	"./component/home/ImgBlocks/": [
		39,
		9,
		2,
		25,
		43
	],
	"./component/home/ImgBlocks/index": [
		39,
		9,
		2,
		25,
		43
	],
	"./component/home/ImgBlocks/index.js": [
		39,
		9,
		2,
		25,
		43
	],
	"./component/home/MultipleTabs": [
		40,
		9,
		0,
		1,
		5,
		4,
		26
	],
	"./component/home/MultipleTabs/": [
		40,
		9,
		0,
		1,
		5,
		4,
		26
	],
	"./component/home/MultipleTabs/index": [
		40,
		9,
		0,
		1,
		5,
		4,
		26
	],
	"./component/home/MultipleTabs/index.js": [
		40,
		9,
		0,
		1,
		5,
		4,
		26
	],
	"./component/home/PressBlock": [
		42,
		9,
		0,
		1,
		2,
		33
	],
	"./component/home/PressBlock/": [
		42,
		9,
		0,
		1,
		2,
		33
	],
	"./component/home/PressBlock/index": [
		42,
		9,
		0,
		1,
		2,
		33
	],
	"./component/home/PressBlock/index.js": [
		42,
		9,
		0,
		1,
		2,
		33
	],
	"./component/home/ServiceBlock": [
		41,
		9,
		44
	],
	"./component/home/ServiceBlock/": [
		41,
		9,
		44
	],
	"./component/home/ServiceBlock/index": [
		41,
		9,
		44
	],
	"./component/home/ServiceBlock/index.js": [
		41,
		9,
		44
	],
	"./component/home/Slider": [
		38,
		9,
		0,
		1,
		2,
		5,
		29
	],
	"./component/home/Slider/": [
		38,
		9,
		0,
		1,
		2,
		5,
		29
	],
	"./component/home/Slider/index": [
		38,
		9,
		0,
		1,
		2,
		5,
		29
	],
	"./component/home/Slider/index.js": [
		38,
		9,
		0,
		1,
		2,
		5,
		29
	],
	"./component/home/TopNav": [
		44,
		9,
		0,
		1,
		4,
		6,
		34
	],
	"./component/home/TopNav/": [
		44,
		9,
		0,
		1,
		4,
		6,
		34
	],
	"./component/home/TopNav/index": [
		44,
		9,
		0,
		1,
		4,
		6,
		34
	],
	"./component/home/TopNav/index.js": [
		44,
		9,
		0,
		1,
		4,
		6,
		34
	],
	"./component/home/TopTabs": [
		35,
		9,
		0,
		1,
		6,
		46
	],
	"./component/home/TopTabs/": [
		35,
		9,
		0,
		1,
		6,
		46
	],
	"./component/home/TopTabs/index": [
		35,
		9,
		0,
		1,
		6,
		46
	],
	"./component/home/TopTabs/index.js": [
		35,
		9,
		0,
		1,
		6,
		46
	],
	"./component/home/index": [
		45,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./component/home/index.js": [
		45,
		9,
		0,
		1,
		2,
		3,
		24
	],
	"./component/myorder": [
		65,
		9,
		57
	],
	"./component/myorder/": [
		65,
		9,
		57
	],
	"./component/myorder/index": [
		65,
		9,
		57
	],
	"./component/myorder/index.js": [
		65,
		9,
		57
	],
	"./component/orders": [
		66,
		9,
		0,
		1,
		4,
		7,
		27
	],
	"./component/orders/": [
		66,
		9,
		0,
		1,
		4,
		7,
		27
	],
	"./component/orders/card": [
		140,
		9,
		7,
		87
	],
	"./component/orders/card.js": [
		140,
		9,
		7,
		87
	],
	"./component/orders/index": [
		66,
		9,
		0,
		1,
		4,
		7,
		27
	],
	"./component/orders/index.js": [
		66,
		9,
		0,
		1,
		4,
		7,
		27
	],
	"./component/product": [
		67,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./component/product/": [
		67,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./component/product/ProductSwiper": [
		52,
		9,
		5,
		8,
		40
	],
	"./component/product/ProductSwiper/": [
		52,
		9,
		5,
		8,
		40
	],
	"./component/product/ProductSwiper/index": [
		52,
		9,
		5,
		8,
		40
	],
	"./component/product/ProductSwiper/index.js": [
		52,
		9,
		5,
		8,
		40
	],
	"./component/product/ProductSwiper/styles.module.scss": [
		237,
		7,
		140
	],
	"./component/product/index": [
		67,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./component/product/index-old": [
		153,
		9,
		0,
		1,
		2,
		3,
		70
	],
	"./component/product/index-old.js": [
		153,
		9,
		0,
		1,
		2,
		3,
		70
	],
	"./component/product/index.js": [
		67,
		9,
		0,
		1,
		2,
		3,
		11
	],
	"./component/product/modal.product": [
		135,
		9,
		107
	],
	"./component/product/modal.product.js": [
		135,
		9,
		107
	],
	"./component/product/oldindex": [
		154,
		9,
		0,
		1,
		2,
		3,
		71
	],
	"./component/product/oldindex.js": [
		154,
		9,
		0,
		1,
		2,
		3,
		71
	],
	"./component/product/test": [
		155,
		9,
		0,
		1,
		2,
		3,
		72
	],
	"./component/product/test.js": [
		155,
		9,
		0,
		1,
		2,
		3,
		72
	],
	"./component/product/videoBlock.product": [
		156,
		9,
		2,
		5,
		89
	],
	"./component/product/videoBlock.product.js": [
		156,
		9,
		2,
		5,
		89
	],
	"./index": [
		27,
		9
	],
	"./index.js": [
		27,
		9
	],
	"./layout": [
		22,
		9
	],
	"./layout/": [
		22,
		9
	],
	"./layout/AuthLayout": [
		28,
		9
	],
	"./layout/AuthLayout.js": [
		28,
		9
	],
	"./layout/index": [
		22,
		9
	],
	"./layout/index.js": [
		22,
		9
	],
	"./pages": [
		87,
		9,
		67
	],
	"./pages/": [
		87,
		9,
		67
	],
	"./pages/Auth/forgotPwd": [
		157,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./pages/Auth/forgotPwd.js": [
		157,
		9,
		0,
		1,
		2,
		3,
		83
	],
	"./pages/Auth/login": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./pages/Auth/login.js": [
		158,
		9,
		0,
		1,
		2,
		3,
		84
	],
	"./pages/Auth/resetPwd": [
		159,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./pages/Auth/resetPwd.js": [
		159,
		9,
		0,
		1,
		2,
		3,
		85
	],
	"./pages/Auth/signup": [
		160,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/Auth/signup.js": [
		160,
		9,
		0,
		1,
		2,
		3,
		86
	],
	"./pages/BlogDetail": [
		76,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/BlogDetail/": [
		76,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/BlogDetail/index": [
		76,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/BlogDetail/index.js": [
		76,
		9,
		0,
		1,
		2,
		3,
		17
	],
	"./pages/Blogs": [
		77,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/Blogs/": [
		77,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/Blogs/index": [
		77,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/Blogs/index.js": [
		77,
		9,
		0,
		1,
		2,
		3,
		12
	],
	"./pages/Cart": [
		78,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/Cart/": [
		78,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/Cart/index": [
		78,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/Cart/index.js": [
		78,
		9,
		0,
		1,
		2,
		3,
		14
	],
	"./pages/Category": [
		79,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Category/": [
		79,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Category/index": [
		79,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/Category/index.js": [
		79,
		9,
		0,
		1,
		2,
		3,
		18
	],
	"./pages/ContactUs": [
		80,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/ContactUs/": [
		80,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/ContactUs/index": [
		80,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/ContactUs/index.js": [
		80,
		9,
		0,
		1,
		2,
		3,
		23
	],
	"./pages/CustomerService": [
		81,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/CustomerService/": [
		81,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/CustomerService/index": [
		81,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/CustomerService/index.js": [
		81,
		9,
		0,
		1,
		2,
		3,
		16
	],
	"./pages/Dummy/dummy": [
		161,
		9,
		0,
		1,
		2,
		3,
		79
	],
	"./pages/Dummy/dummy.js": [
		161,
		9,
		0,
		1,
		2,
		3,
		79
	],
	"./pages/Dummy/static": [
		162,
		9,
		0,
		1,
		2,
		3,
		74
	],
	"./pages/Dummy/static.js": [
		162,
		9,
		0,
		1,
		2,
		3,
		74
	],
	"./pages/Home": [
		82,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/Home/": [
		82,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/Home/index": [
		82,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/Home/index.js": [
		82,
		9,
		0,
		1,
		2,
		3,
		22
	],
	"./pages/MyOrder": [
		83,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/MyOrder/": [
		83,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/MyOrder/index": [
		83,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/MyOrder/index.js": [
		83,
		9,
		0,
		1,
		2,
		3,
		15
	],
	"./pages/Orders": [
		84,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Orders/": [
		84,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Orders/index": [
		84,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/Orders/index.js": [
		84,
		9,
		0,
		1,
		2,
		3,
		13
	],
	"./pages/OurExperienceCenters": [
		85,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/OurExperienceCenters/": [
		85,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/OurExperienceCenters/index": [
		85,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/OurExperienceCenters/index.js": [
		85,
		9,
		0,
		1,
		2,
		3,
		19
	],
	"./pages/OurExperienceCenters/style.module.scss": [
		267,
		7,
		141
	],
	"./pages/Product": [
		86,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/Product/": [
		86,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/Product/index": [
		86,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/Product/index.js": [
		86,
		9,
		0,
		1,
		2,
		3,
		10
	],
	"./pages/about": [
		56,
		9,
		47
	],
	"./pages/about/": [
		56,
		9,
		47
	],
	"./pages/about/index": [
		56,
		9,
		47
	],
	"./pages/about/index.js": [
		56,
		9,
		47
	],
	"./pages/about/style.module.scss": [
		250,
		7,
		142
	],
	"./pages/index": [
		87,
		9,
		67
	],
	"./pages/index.js": [
		87,
		9,
		67
	],
	"./pages/kitchen-mate": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/kitchen-mate/": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/kitchen-mate/index": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/kitchen-mate/index.js": [
		88,
		9,
		0,
		1,
		2,
		3,
		20
	],
	"./pages/kitchen-mate/snackChef": [
		163,
		9,
		0,
		1,
		2,
		3,
		80
	],
	"./pages/kitchen-mate/snackChef.js": [
		163,
		9,
		0,
		1,
		2,
		3,
		80
	],
	"./pages/kitchen-mate/snackChefs": [
		164,
		9,
		0,
		1,
		2,
		3,
		81
	],
	"./pages/kitchen-mate/snackChefs.js": [
		164,
		9,
		0,
		1,
		2,
		3,
		81
	],
	"./pages/kitchen-mate/style.module.scss": [
		252,
		7,
		143
	],
	"./pages/terms-use": [
		55,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/terms-use/": [
		55,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/terms-use/index": [
		55,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/terms-use/index.js": [
		55,
		9,
		0,
		1,
		2,
		3,
		21
	],
	"./pages/terms-use/style.module.scss": [
		249,
		7,
		144
	],
	"./redux/actions/actions": [
		14,
		9
	],
	"./redux/actions/actions.js": [
		14,
		9
	],
	"./redux/actions/productAction": [
		125,
		9,
		108
	],
	"./redux/actions/productAction.js": [
		125,
		9,
		108
	],
	"./redux/actions/userAction": [
		165,
		9,
		0,
		1,
		94
	],
	"./redux/actions/userAction.js": [
		165,
		9,
		0,
		1,
		94
	],
	"./redux/reducers": [
		23,
		9
	],
	"./redux/reducers/": [
		23,
		9
	],
	"./redux/reducers/index": [
		23,
		9
	],
	"./redux/reducers/index.js": [
		23,
		9
	],
	"./redux/reducers/taskReducer": [
		31,
		9
	],
	"./redux/reducers/taskReducer.js": [
		31,
		9
	],
	"./redux/store/store": [
		16,
		9
	],
	"./redux/store/store.js": [
		16,
		9
	],
	"./redux_old/actions/actionTypes": [
		133,
		9,
		109
	],
	"./redux_old/actions/actionTypes.js": [
		133,
		9,
		109
	],
	"./redux_old/actions/commonAction": [
		166,
		9,
		98
	],
	"./redux_old/actions/commonAction.js": [
		166,
		9,
		98
	],
	"./redux_old/actions/productAction": [
		167,
		9,
		99
	],
	"./redux_old/actions/productAction.js": [
		167,
		9,
		99
	],
	"./redux_old/reducer": [
		68,
		9,
		58
	],
	"./redux_old/reducer/": [
		68,
		9,
		58
	],
	"./redux_old/reducer/commonStore": [
		141,
		9,
		100
	],
	"./redux_old/reducer/commonStore.js": [
		141,
		9,
		100
	],
	"./redux_old/reducer/index": [
		68,
		9,
		58
	],
	"./redux_old/reducer/index.js": [
		68,
		9,
		58
	],
	"./redux_old/reducer/productStore": [
		142,
		9,
		101
	],
	"./redux_old/reducer/productStore.js": [
		142,
		9,
		101
	],
	"./redux_old/store": [
		89,
		9,
		45
	],
	"./redux_old/store/": [
		89,
		9,
		45
	],
	"./redux_old/store/index": [
		89,
		9,
		45
	],
	"./redux_old/store/index.js": [
		89,
		9,
		45
	],
	"./routes": [
		21,
		9
	],
	"./routes/": [
		21,
		9
	],
	"./routes/index": [
		21,
		9
	],
	"./routes/index.js": [
		21,
		9
	],
	"./routes/routes": [
		30,
		9
	],
	"./routes/routes.js": [
		30,
		9
	],
	"./service/apis": [
		54,
		9,
		60
	],
	"./service/apis/": [
		54,
		9,
		60
	],
	"./service/apis/blogs.apis": [
		130,
		9,
		0,
		1,
		95
	],
	"./service/apis/blogs.apis.js": [
		130,
		9,
		0,
		1,
		95
	],
	"./service/apis/customer.apis": [
		126,
		9,
		0,
		1,
		92
	],
	"./service/apis/customer.apis.js": [
		126,
		9,
		0,
		1,
		92
	],
	"./service/apis/index": [
		54,
		9,
		60
	],
	"./service/apis/index.js": [
		54,
		9,
		60
	],
	"./service/apis/products.apis": [
		123,
		9,
		0,
		1,
		96
	],
	"./service/apis/products.apis.js": [
		123,
		9,
		0,
		1,
		96
	],
	"./service/graphql": [
		33,
		9,
		0,
		68
	],
	"./service/graphql/": [
		33,
		9,
		0,
		68
	],
	"./service/graphql/apiQuery": [
		124,
		9,
		1,
		88
	],
	"./service/graphql/apiQuery.js": [
		124,
		9,
		1,
		88
	],
	"./service/graphql/index": [
		33,
		9,
		0,
		68
	],
	"./service/graphql/index.js": [
		33,
		9,
		0,
		68
	],
	"./serviceWorker": [
		32,
		9
	],
	"./serviceWorker.js": [
		32,
		9
	],
	"./utils/CodeSplitter": [
		17,
		9
	],
	"./utils/CodeSplitter.js": [
		17,
		9
	],
	"./utils/Constants": [
		168,
		9,
		110
	],
	"./utils/Constants.js": [
		168,
		9,
		110
	],
	"./utils/CouponDisplay": [
		136,
		9,
		90
	],
	"./utils/CouponDisplay.js": [
		136,
		9,
		90
	],
	"./utils/Currency": [
		129,
		9,
		111
	],
	"./utils/Currency.js": [
		129,
		9,
		111
	],
	"./utils/FormValidation": [
		134,
		9,
		112
	],
	"./utils/FormValidation.js": [
		134,
		9,
		112
	],
	"./utils/MetaData": [
		18,
		9
	],
	"./utils/MetaData.js": [
		18,
		9
	],
	"./utils/helperFunctions": [
		132,
		9,
		113
	],
	"./utils/helperFunctions.js": [
		132,
		9,
		113
	],
	"./utils/mock": [
		137,
		9,
		114
	],
	"./utils/mock.js": [
		137,
		9,
		114
	],
	"./utils/temp": [
		131,
		3,
		116
	],
	"./utils/temp.json": [
		131,
		3,
		116
	],
	"./utils/toast": [
		127,
		9,
		93
	],
	"./utils/toast.js": [
		127,
		9,
		93
	],
	"./utils/validation": [
		169,
		9,
		9,
		102
	],
	"./utils/validation.js": [
		169,
		9,
		9,
		102
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 176;
module.exports = webpackAsyncContext;